import { DatePickerInput } from '@delmonicos/shared-design-system-react/src/components/date-picker-input/date-picker-input';
import {
  ModeEnum,
  coerceDatePickerRangeSelection,
} from '@delmonicos/shared-design-system-react/src/components/date-picker/date-picker';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Toggle } from '@delmonicos/shared-design-system-react/src/components/toggle/toggle';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { usePullTariffsFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/tariffs/pull-tariffs.form-validation';
import { PullTariffsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/tariffs/pull-tariffs.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const EmspBoTariffPullCreateFormStep1Controller =
  (): React.JSX.Element => {
    const { t } = useTranslation();
    const { control } = useFormContext<PullTariffsModel>();
    const { updatedAfter, updatedBefore, removeMarkedForDeletion } =
      usePullTariffsFormValidation();

    return (
      <Stack direction="column" gap={GapEnum.L}>
        <Controller
          name="updatedAfter"
          control={control}
          rules={updatedAfter}
          render={({ field: fieldUpdatedAfter }) => (
            <Controller
              name="updatedBefore"
              control={control}
              rules={updatedBefore}
              render={({ field: fieldUpdatedBefore }) => (
                <Stack direction="column" gap={GapEnum.XS}>
                  <Text fontSize={TextFontSize.Small} uppercase>
                    {t(
                      'delmonicos-shared-sdk.inputs-pull-tariffs.updated-after',
                    )}{' '}
                    /{' '}
                    {t(
                      'delmonicos-shared-sdk.inputs-pull-tariffs.updated-before',
                    )}
                  </Text>
                  <DatePickerInput
                    mode={ModeEnum.Range}
                    selected={{
                      from: fieldUpdatedAfter.value
                        ? new Date(fieldUpdatedAfter.value as Date)
                        : undefined,
                      to: fieldUpdatedBefore.value
                        ? new Date(fieldUpdatedBefore.value as Date)
                        : undefined,
                    }}
                    onSelect={(...args) => {
                      const range = coerceDatePickerRangeSelection(...args);
                      fieldUpdatedAfter.onChange(range?.from ?? undefined);
                      fieldUpdatedBefore.onChange(range?.to ?? undefined);
                    }}
                  />
                </Stack>
              )}
            />
          )}
        />
        <Controller
          name="removeMarkedForDeletion"
          control={control}
          rules={removeMarkedForDeletion}
          render={({ field }) => (
            <Toggle
              id="remove-marked-for-deletion"
              label={t(
                'delmonicos-shared-sdk.inputs-pull-tariffs.remove-marked-for-deletion',
              )}
              checked={field.value ?? false}
              onChange={field.onChange}
            />
          )}
        />
      </Stack>
    );
  };
